/* eslint-disable */
<template>
  <section class='content'>
    <div class='container-fluid'>
      <div class='block-header'>
        <h2>{{ nama }}</h2>
      </div>
      <div class='row clearfix'>
        <div class='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
          <div class='card'>
            <div class='header'>
              <h2>{{ id != null ? 'Edit' : 'Tambah' }} {{ nama }}</h2>
            </div>
            <div class='body'>
              <form class='form-horizontal' v-on:submit.prevent='onSubmit'>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='nip'>Nip</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='nip'
                        type='text'
                        v-model='data.nip'
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='Pertanyaan'>Pertanyaan</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='Pertanyaan'
                        type='text'
                        v-model='data.pesan'
                        :disabled="true"
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='Jenis'>Jenis Pengajuan</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='Jenis'
                        type='text'
                        v-model='data.jenisPengajuan'
                        :disabled="true"
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='jawaban'>Jawaban</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='jawaban'
                        type='text'
                        v-model='data.jawaban'
                      ></form-line>
                    </div>
                  </div>
                </div>
                <!-- <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='jawaban'>jawaban</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <Ckeditor
                        id='jawaban'
                        ref="ckeditor"
                        v-model='data.jawaban'
                        :config='config'
                        ></Ckeditor>
                    </div>
                  </div>
                </div> -->
                <div class='row clearfix'>
                  <div
                    class='col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5'
                  >
                    <button
                      v-if='id != null'
                      @click='update'
                      type='button'
                      class='btn btn-warning waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i> Edit
                    </button>
                    <button
                      v-else
                      @click='save'
                      type='button'
                      class='btn btn-primary waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i>
                      Simpan
                    </button>
                    <button
                      @click='$router.go(-1)'
                      type='button'
                      class='btn btn-danger'
                      v-waves.button
                    >
                      <i class='material-icons'>cancel</i> Batal
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import Ckeditor from 'vue-ckeditor2'
import FormLine from '@/components/FormLine.vue'
import api from '@/helper/api'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

export default {
  components: { FormLine, Ckeditor, vueDropzone: vue2Dropzone },
  name: 'KritikDanSaran',
  data: function () {
    return {
      categories: [],
      data: {
        jawaban: '',
        nip: '',
        jenisPengajuan: '',
      },
      tanggal: '',
      file: '',
      id: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false,
      init: false
    }
  },
  methods: {
    update () {
      this.isLoading = true
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .post('/sendJawabanPertanyaanKritikdanSaran/' + this.id, this.data)
        .then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/Layanan/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        })
        .catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
    }, 
    getDetail () {
      this.init = true
      console.log("ini file get data edit",this.filepertanyaanKritikdanSaranId)
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .get('/getPertanyaanKritikdanSaranById/' + this.id)
        .then((result) => {
          this.data = result.data.object
          this.init = false
        })
        .catch((ex) => {
          console.error("Error getDetail:", ex)
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.init = false
        })
    },
    onSubmit () {
      if (this.id != null) this.update()
      else this.save()
    },
    checkRoute (route) {
      console.log(route.name)
      if (route.name === 'TambahKritikDanSaran' || route.name === 'EditKritikDanSaran') {
        this.link = 'KritikDanSaran'
        this.nama = 'Kritik dan Saran'
      }
    },
    delete (id) {
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .delete('//' + id)
        .then((result) => {
          console.log(result.data.code)
          if (result.data.code === 200) {
            this.$toastr.s('Foto berhasil dihapus')
            this.$swal.close()
          } else {
            this.$toastr.e('Gagal menghapus foto')
            this.$swal.close()
          }
        })
        .catch((e) => {
          this.$swal.close()
        })
    }
  },
  mounted () {
    this.checkRoute(this.$route)
    this.id = this.$route.params.id
    if (this.id != null) {
      this.getDetail()
    }
  },
  watch: {
    $route (to, from) {
      this.checkRoute(to)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/KritikdanSaran/KritikDanSaran.vue